// Картата на една променена цена на телефон. Общата транспозиция „ред на
// колона" би направила от 10 колони карта от 10 реда — на екран влиза един
// запис. Тук първият ред носи това, което човек търси: кой продукт и колко
// е отнето (или добавено) от сметката.

import { EM_DASH, formatDateTime } from "../../../../components/dataTable";
import { fmtEuro } from "../../../../utils/currency";
import type { PriceChangeRow } from "./priceChangesMath";

/** Минус знак U+2212 — както в колоната „Разлика". */
const MINUS = "−";

/** Стрелка „стара → нова цена" — един символ вместо две думи. */
const ARROW = "→";

export const PriceChangeMobileCard = ({ row }: { row: PriceChangeRow }) => {
  const changed = formatDateTime(row.changedAt, "auto");
  const isDown = row.lineDifference < 0;

  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex items-center gap-2">
        <span className="min-w-0 flex-1 truncate text-[15px] font-bold text-ink">
          {row.itemLabel}
        </span>
        <span
          className={`font-pos-mono text-[15px] font-bold tabular-nums ${
            isDown ? "text-danger-ink" : "text-info-deep"
          }`}
        >
          {`${isDown ? MINUS : "+"}${fmtEuro(Math.abs(row.lineDifference))}`}
        </span>
      </div>

      <div className="flex flex-wrap items-center gap-x-2 gap-y-0.5 text-[12px] font-medium text-muted">
        <span className="font-pos-mono tabular-nums">{changed.time}</span>
        {changed.date ? (
          <span className="font-pos-mono tabular-nums">{changed.date}</span>
        ) : null}
        <span aria-hidden>·</span>
        <span className="truncate">{row.billLabel}</span>
        <span aria-hidden>·</span>
        <span className="truncate">{row.userLabel || EM_DASH}</span>
      </div>

      <div className="flex flex-wrap items-center gap-x-2 gap-y-0.5 text-[12px] font-medium text-soft">
        <span className="font-pos-mono tabular-nums">
          {`${fmtEuro(row.oldPrice)} ${ARROW} ${fmtEuro(row.newPrice)}`}
        </span>
        <span aria-hidden>·</span>
        <span className="font-pos-mono tabular-nums">
          {`${isDown ? MINUS : "+"}${Math.abs(row.percent).toFixed(2)} %`}
        </span>
        {row.additionHint ? (
          <>
            <span aria-hidden>·</span>
            <span>{row.additionHint}</span>
          </>
        ) : null}
      </div>
    </div>
  );
};
